import React from 'react';
import { Flex as RebassFlex } from 'rebass';

const Flex = props => <RebassFlex {...props} />;

export default Flex;
